export default "__VITE_ASSET__616bec39__"